import React from 'react'
import {IKmFilterModel} from '../CarModel'
import DataTable, {TableColumn} from '../../../../shared/components/DataTable'

type Props = {
  data: IKmFilterModel[]
  currentPage: number
  totalPages: number
  pageSize: number
  onPageSizeChange?: (size: number) => void 
  onPageChange: (page: number) => void // Düzeltme: parametre tipi eklendi
  onEdit?: (branch: IKmFilterModel) => void // Düzeltme: Edit fonksiyonu eklendi
  onDelete?: (branch: IKmFilterModel) => void // Düzeltme: Delete fonksiyonu eklendi
  sortBy?: string // Düzeltme: Sort state'leri eklendi
  sortOrder?: 'asc' | 'desc'
  onSort?: (column: string, order: 'asc' | 'desc') => void
  loading?: boolean
}

export const KmLogTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  pageSize,
  onPageSizeChange,
  onPageChange,
  onEdit,
  onDelete,
  sortBy,
  sortOrder,
  onSort,
  loading = false,
}) => {
  const branchColumns: TableColumn<IKmFilterModel>[] = [
    {key: 'plate', label: 'Plaka', className: 'fw-semibold', sortable: true},
    {key: 'operationType', label: 'İşlem Türü', sortable: true},
    {key: 'startDate', label: 'Başlangıç Tarihi', sortable: true},
    {key: 'endDate', label: 'Bitiş Tarihi', sortable: true},
    {key: 'departureKm', label: 'Çıkış KM', sortable: true},
    {key: 'returnKm', label: 'Dönüş KM', sortable: true},
    {key: 'difference', label: 'Fark', sortable: true},
    {key: 'intermediateDifference', label: 'Ara Fark', sortable: true},
    {key: 'departureOffice', label: 'Çıkış Ofisi'},
    {key: 'returnOffice', label: 'Dönüş Ofisi'},
  ]

  return (
    <DataTable
      data={data}
      columns={branchColumns}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      pageSize={pageSize}
      onPageSizeChange={onPageSizeChange}
      onPageChange={onPageChange}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSort={onSort}
      loading={loading}
      emptyMessage='Kayıt bulunamadı'
    />
  )
}
